// 原来的
// const BASE_URL = 'https://manage.yishush.cn'
// const WEB_URL = 'https://client.yishush.cn'
// const MINIPROGRAM_URL = 'https://miniprogram.yishush.cn'




// 基础域名（提取公共部分，减少冗余）
const BASE_DOMAIN = 'yishush.cn';

// 各服务基础URL配置
const BASE_URL = `https://manage.${BASE_DOMAIN}`;
const WEB_URL = `https://client.${BASE_DOMAIN}`;
const MINIPROGRAM_URL = `https://miniprogram.${BASE_DOMAIN}`;


export {
  BASE_URL,
  WEB_URL,
  MINIPROGRAM_URL
}